/**
 * 전투기록 창의 [시뮬레이션] → 시뮬레이션 탭으로 그 전투를 넘긴다.
 *
 * 탭을 바꾸면 시뮬레이션 화면이 새로 뜨므로 이벤트만으로는 받을 자리가 없다 — 여기 맡겨 두고,
 * 시뮬레이션 화면이 뜰 때 한 번 꺼내 간다(`takeSimBattle`).
 */
export interface SimBattle {
    /** 전투 열쇠(서버 utils/battleRef, `siegeId-logType-logId`) */
    ref: string;
    logId: number;
    result: string;
    battledAt: string;
    wizardName: string;
    oppWizardName?: string;
    oppGuildName?: string;
    attackTeam: Array<{ unitMasterId: number; name: string; attribute: string }>;
    defenseTeam: Array<{ unitMasterId: number; name: string; attribute: string }>;
}

let pending: SimBattle | null = null;

/** 맡겨 두고 시뮬레이션 탭으로 간다(PageContainer 가 `swpvpdb:open-sim` 을 듣는다) */
export function openInSim(b: SimBattle): void {
    pending = b;
    window.dispatchEvent(new CustomEvent('swpvpdb:open-sim'));
}

export function takeSimBattle(): SimBattle | null {
    const b = pending;
    pending = null;
    return b;
}

/**
 * 전적검색의 학습 결과 줄 → 시뮬레이션 탭에서 그 방덱·공덱으로 칸을 채운다(SimPage `loadLearned` — 학습 기록 창에서 고른 것과 같은 길).
 * 기록 모양은 SimMemory 의 MemoryRecord·MemoryDeck — 여기서는 그대로 넘기기만 한다.
 */
let pendingLearned: { rec: any; deck: any } | null = null;

export function openLearnedInSim(rec: any, deck: any): void {
    pendingLearned = { rec, deck };
    window.dispatchEvent(new CustomEvent('swpvpdb:open-sim'));
}

export function takeSimLearned(): { rec: any; deck: any } | null {
    const l = pendingLearned;
    pendingLearned = null;
    return l;
}
